// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const leavanny: PokeData = {
  "id": 542,
  "name": "leavanny",
  "height": 12,
  "weight": 205,
  "base_experience": 225,
  "types": [
    PokeType.BUG,
    PokeType.GRASS
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "razor-leaf",
    "string-shot",
    "slash",
    "false-swipe",
    "helping-hand",
    "leaf-blade",
    "x-scissor",
    "leaf-storm",
    "bug-bite",
    "entrainment",
    "struggle-bug",
    "fell-stinger"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "string-shot",
    "bug-bite",
    "energy-ball",
    "signal-spam",
    "bug-buzz",
    "power-whip",
    "vine-whip",
    "pounce",
    "bullet-seed",
    "infest",
    "pin-missile"
  ],
  "evolution_chain": {
    "id": 276,
    "item": null,
    "species": [
      {
        "name": "sewaddle",
        "order": 541,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swadloon",
        "order": 542,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 540,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "leavanny",
        "order": 543,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 541,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 135,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
